import '../styles/application.sass'

import 'babel-polyfill'
import ReactOnRails from 'react-on-rails'

import appStore from '../src/store'

// Register the one of the stores in react-on-rails
ReactOnRails.registerStore({ appStore })

// Register the all components in react-on-rails
const normalizeFilename = fileName =>
  fileName.substr(2, fileName.length - 6).replace(/\b\w/g, l => l.toUpperCase())
const components = require.context('../src/components', true, /\.jsx$/)

components.keys().forEach(fileName =>
  ReactOnRails.register({ [normalizeFilename(fileName)]: components(fileName).default }))

window.addEventListener('error', function(event) {
  window.location.reload()
})



// WEBPACK FOOTER //
// app/javascript/packs/application.js